import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const inOutward = defineAsyncComponent(() => import('@/views/tools/inOutwardTab/InOutwardDetail.vue'));
const inInward = defineAsyncComponent(() => import('@/views/tools/inInward/INInwardDetail.vue'));

export function registerOutward(app) {
  const registerConfig = {
    INOutwardDetail: inOutward,
    INInwardDetail: inInward,
    InventoryInwardCashDetail: inInward,
    InventoryInwardDepositDetail: inInward,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'Tools');
}
